import { CommandBase } from "../../../common/services/cqs/commandManager";

export class UpdateArbetsorderAnteckningProdplanCommand extends CommandBase {
    arbetsorderGuid: string;
    anteckning: string;

    constructor(init: (instance: UpdateArbetsorderAnteckningProdplanCommand) => void) {
        super("UpdateArbetsorderAnteckningProdplanCommand");
        init(this);
    }
}
